module.exports = __webpack_public_path__ + "static/media/ground_glass.a083d63b.jpg";